import {API} from "../../../api/api";
import {ConfigurationsAPIRoutes} from "./apiRoutes";
import {skeletonStoreSelectors} from "../../../store";
import axios from "axios";

import {removeAccents} from "../../../utils/utils";

const _getHalls = ({page, search = null}) => {
    const odataParameters = {
        skip: page * 10,
        top: 10,
        orderby: "-created_on"
    };

    if (search) {
        odataParameters["search"] = search;
    }

    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_HALLS,
        odataParameters
    });
};

const _getConfigurationsList = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_CONFIGURATIONS_LIST
    });
};

const _downloadConfiguration = ({
                                    server,
                                    serverName,
                                    configVersion,
                                    config,
                                    updateTime = undefined
                                }) => {
    const routes = skeletonStoreSelectors.apiRoutes();

    const route =
        API.baseURL +
        routes[ConfigurationsAPIRoutes.DOWNLOAD_CONFIGURATION].path
            .replace(":server_id:", server)
            .replace(":configuration_id:", config);

    const request =
        updateTime == undefined
            ? axios.get(route, {
                responseType: "blob",
                headers: API.getHeaders()
            })
            : axios.get(route, {
                responseType: "blob",
                headers: API.getHeaders(),
                params: {
                    update_time: updateTime
                }
            });

    return request
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute(
                "download",
                `server-${removeAccents(
                    serverName.replace(/ /g, "_").replace(/[^\w\s]/gi, "")
                )}_config-v${configVersion}.ssc`
            );
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            if (error.response.status == 400) {
                API.handleError({status: 8701});
            } else {
                API.handleError(
                    undefined,
                    "An error occured while downloading file."
                );
            }
        });
};

/*const _listSchemas = (subsidiary, server_type) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.LIST_SCHEMAS,
        routeParameters: {
            subsidiary,
            server_type
        }
    });
};*/

const _getSchema = (subsidiary, version, server_type) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_SCHEMA,
        routeParameters: {
            subsidiary,
            version,
            server_type
        }
    });
};

const _getConfiguration = ({serverId, config}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_CONFIGURATION,
        routeParameters: {
            configuration_id: config,
            server_id: serverId
        }
    });
};

const _createConfiguration = ({serverId, config}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.NEW_CONFIGURATION,
        parameters: {...config},
        routeParameters: {
            server_id: serverId
        },
        formData: false
    });
};

const _editConfiguration = ({config, serverId}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.EDIT_CONFIGURATION,
        parameters: {...config},
        routeParameters: {server_id: serverId},
        formData: false
    });
};

const _getHallInfo = ({hallId}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_HALL_INFO_WITH_ID,
        routeParameters: {
            hall_id: hallId
        }
    });
};

const getServer = ({serverId}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_SERVER,
        routeParameters: {
            server_id: serverId
        }
    });
};

const _getCoreVersions = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_CORE_VERSIONS,
        odataParameters: {}
    });
};

const _getDenominations = ({countryId}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_DENOMINATIONS,
        odataParameters: {
            filter: `country_id eq ${countryId}`
        }
    });
};

const _getCurrencies = ({subsidiaryId}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_CURRENCIES,
        odataParameters: {
            filter: `subsidiary_id eq ${subsidiaryId}`
        }
    });
};

const _getGameInstances = ({
                               subsidiary,
                               skip,
                               top
                           }: {
    subsidiary: number;
    skip?: number;
    top?: number;
}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_GAME_INSTANCES_CONFIGS,
        odataParameters: {
            skip,
            top,
            filter: `subsidiary_id eq ${subsidiary} and active eq true`
        }
    });
};

const _loadGameConfigurations = ({subsidiary}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_GAME_CONFIGS,
        routeParameters: {
            subsidiary_id: subsidiary
        }
    });
};

const _getDecibels = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_SOUND_DECIBELS,
        odataParameters: {}
    });
};

const _getPercentages = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_SOUND_PERCENTAGE,
        odataParameters: {}
    });
};

const _getSoundServer = ({serverId, version}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_SOUND_SERVER_SETTINGS,
        routeParameters: {
            server_id: serverId,
            version: version.toString()
        }
    });
};

const _getSoundGroups = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_SOUND_GROUPS,
        odataParameters: {}
    });
};

const _getRTPProfiles = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_RTP_PROFILES,
        odataParameters: {
            skip: 0,
            top: 10000
        }
    });
};

const _getProgressiveTypes = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_PROGRESSIVE_TYPES
    });
};

const _getProgressiveRules = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_PROGRESSIVE_RULES
    });
};

const _getProgressivePresets = (subsidiary, isDetail, isDebug) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_PROGRESSIVE_PRESETS,
        odataParameters: {
            skip: 0,
            top: 10000,
            filter: (isDetail
                    ? `subsidiary_id eq ${subsidiary} or subsidiary_id eq null`
                    : `(subsidiary_id eq ${subsidiary} or subsidiary_id eq null) and active eq true`) +
                (!isDebug ? ` and certified eq true` : ``)
        }
    });
};

const _getGameBundles = ({skip, top}) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_BUNDLES,
        odataParameters: {
            skip,
            top
        }
    });
};

/*const _getBasicGame = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_GAME,
        routeParameters: {
            game_id: "500"
        }
    });
};*/

const _getBasicGames = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_GAMES,
        odataParameters: {
            skip: 0,
            top: 100,
            filter: `id in (${[500, 511, 502, 503, 513]
                .map(c => c)
                .join(",")},)`
        }
    });
};

const _getRegions = subsidiary => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_REGIONS,
        routeParameters: {
            subsidiary_id: subsidiary
        }
    });
};

const _getMailingLists = subsidiary => {
    let odataParameters = {filter: `active eq true and subsidiary_id in (${subsidiary},)`};

    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_MAILING_LISTS,
        odataParameters
    });
};

const getProductionServer = () => {
    return API.request({
        routeID:ConfigurationsAPIRoutes.GET_PRODUCTION_INFO
    })
}

const _getMegapotServerList = (provider,subsidiary) => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_MEGAPOT_SERVER_LIST,
        routeParameters: {
            provider: provider,
            subsidiary: subsidiary
        }
    });
};
const _getMegapotProvidersList = () => {
    return API.request({
        routeID: ConfigurationsAPIRoutes.GET_MEGAPOT_PROVIDERS_LIST
    });
};
export const configurationsAPI = {
    getLoginStatus: API.getLoginStatus,
    getConfigurationsList: _getConfigurationsList,
    getHalls: _getHalls,
    downloadConfiguration: _downloadConfiguration,
    //listSchemas: _listSchemas,
    getSchema: _getSchema,
    getConfiguration: _getConfiguration,
    createConfiguration: _createConfiguration,
    editConfiguration: _editConfiguration,
    getHallInfo: _getHallInfo,
    getDenominations: _getDenominations,
    getServer,
    getGameInstances: _getGameInstances,
    loadGameConfigurations: _loadGameConfigurations,
    getDecibels: _getDecibels,
    getPercentages: _getPercentages,
    getSoundServer: _getSoundServer,
    getSoundGroups: _getSoundGroups,
    getRTPProfiles: _getRTPProfiles,
    getCoreVersions: _getCoreVersions,
    getProgressiveTypes: _getProgressiveTypes,
    getProgressivePresets: _getProgressivePresets,
    getProgressiveRules: _getProgressiveRules,
    getGameBundles: _getGameBundles,
    //getBasicGame: _getBasicGame,
    getBasicGames: _getBasicGames,
    getRegions: _getRegions,
    getMailingLists: _getMailingLists,
    getCurrencies: _getCurrencies,
    getProductionServer,
    getMegapotServerList: _getMegapotServerList,
    getMegapotProvidersList: _getMegapotProvidersList
};
